import { Grid, TextField } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import MeditocModal from "../../../utils/MeditocModal";
import { useEmpresa } from "../../../../context/EmpresaContext";

export default function FormEmpresa() {
    const {
        empresaSeleccionada,
        modalOpenFormEmpresa,
        formEmpresa,
        handleOpenFormEmpresa,
        handleChangeFormEmpresa,
        handleSubmitFormEmpresa,
    } = useEmpresa();

    const { txtFolioEmpresa, txtNombreEmpresa, txtCorreoEmpresa } = formEmpresa;

    return (
        <MeditocModal
            title={empresaSeleccionada.iIdEmpresa === 0 ? "Nueva empresa" : "Editar empresa"}
            okfunc={handleSubmitFormEmpresa}
            setopen={handleOpenFormEmpresa}
            open={modalOpenFormEmpresa}
            okmessage="Guardar"
            size="small"
            form
        >
            <Grid container spacing={3}>
                {empresaSeleccionada.iIdEmpresa > 0 && (
                    <Grid item xs={12}>
                        <TextField
                            name="txtFolioEmpresa"
                            label={txtFolioEmpresa.label}
                            value={txtFolioEmpresa.value}
                            required={txtFolioEmpresa.required}
                            variant={inputVariant}
                            color={inputColor}
                            disabled
                            fullWidth
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <TextField
                        name="txtNombreEmpresa"
                        label={txtNombreEmpresa.label}
                        required={txtNombreEmpresa.required}
                        value={txtNombreEmpresa.value}
                        error={txtNombreEmpresa.error}
                        helperText={txtNombreEmpresa.error && txtNombreEmpresa.message}
                        onChange={handleChangeFormEmpresa}
                        variant={inputVariant}
                        color={inputColor}
                        autoFocus
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtCorreoEmpresa"
                        label={txtCorreoEmpresa.label}
                        required={txtCorreoEmpresa.required}
                        value={txtCorreoEmpresa.value}
                        error={txtCorreoEmpresa.error}
                        helperText={txtCorreoEmpresa.error && txtCorreoEmpresa.message}
                        onChange={handleChangeFormEmpresa}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
